import {
  GetTwoFactorAuth,
  CleanUserDetails,
  LoginSuccessDetails,
  LogoutUser,
  UpdateProfileDetails,
} from "./auth";

import {
  NavToogleInterface,
  PageHasSubNavInterface,
  PushPopupAlertAction,
  RemovePopupAlertAction,
} from "./system";

export enum ActionTypes {
  SET_TWO_FACTOR_AUTH = "SET_TWO_FACTOR_AUTH",
  LOGIN_DETAILS = "LOGIN_DETAILS",
  CLEAN_USER_DETAILS = "CLEAN_USER_DETAILS",
  USER_LOGIN_SUCCESS_DATA = "USER_LOGIN_SUCCESS_DATA",
  LOGOUT = "LOGOUT",
  UPDATE_PROFILE_DETAILS = "UPDATE_PROFILE_DETAILS",
  PAGE_HAS_SUB_NAV = "PAGE_HAS_SUB_NAV",
  NAVIGATION_TOOGLE = "NAVIGATION_TOOGLE",
  PUSH_POPUP_ALERT = "PUSH_POPUP_ALERT",
  REMOVE_POPUP_ALERT = "REMOVE_POPUP_ALERT",
}

export type Action =
  | GetTwoFactorAuth
  | CleanUserDetails
  | LoginSuccessDetails
  | LogoutUser
  | UpdateProfileDetails
  | NavToogleInterface
  | PageHasSubNavInterface
  | PushPopupAlertAction
  | RemovePopupAlertAction;
